import React, { useState, useEffect } from 'react';
import './ContactForm.scss';
import chat from '../../Assets/Icons/chat.png';
import whatsapp from '../../Assets/Icons/whatsapp.png';

import { motion, AnimatePresence } from 'framer-motion';
import {
  fadeinTop,
  pageTransitions,
  fadeinslow,
  fadeinfast,
  contactFormAnimations,
} from '../../animations';

import { useHistory } from 'react-router-dom';
import loader from '../../Assets/loaders/loader1.gif';

import {
  onSnapshot,
  onSnapshotsInSync,
  collection,
  doc,
  addDoc,
} from 'firebase/firestore';
import db from '../../firebaseConfig';
import emailjs from 'emailjs-com';

const ContactForm = () => {
  const [visible, setVisible] = useState(false);
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [comment, setComment] = useState(null);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const collectionRef = collection(db, 'emails');
    const payLoad = { name: name, email: email, message: comment };
    if (name && email && comment) {
      setLoading(true);
      let firebaseRes = await addDoc(collectionRef, payLoad);
      let emailjsRes = await emailjs.sendForm(
        'service_jd7wqu9',
        'template_g57rtth',
        e.target,
        'user_ROKMQhMWUtUpNEPP6gqt6'
      );
      if (emailjsRes && firebaseRes) {
        alert('Form Submitted !');
        setName('');
        setComment('');
        setEmail('');
        setLoading(false);
      }
    } else alert('Enter Valid Data !');
  };

  return (
    <div className="ContactForm">
      <div className="ContactForm__icon" onClick={() => setVisible(!visible)}>
        <img src={chat} />
      </div>
      <AnimatePresence>
        {visible && (
          <motion.form
            className="ContactForm__Form"
            variants={contactFormAnimations}
            initial="hidden"
            animate="visible"
            exit="exit"
            onSubmit={handleSubmit}
          >
            {loading && (
              <div className="ContactForm__Form__Loader">
                <div className="loadingio-spinner-rolling-jgm8s83muo8">
                  <div className="ldio-eszr9074rfm">
                    <div></div>
                  </div>
                </div>
              </div>
            )}
            <div className="ContactForm__Form__First-Line">
              <input
                placeholder="Name"
                onChange={(e) => setName(e.target.value)}
                value={name}
                name="name"
              />
              <input
                placeholder="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                name="email"
              />
            </div>
            <div className="ContactForm__Form__Second-Line">
              <textarea
                placeholder="Leave a message..."
                onChange={(e) => setComment(e.target.value)}
                value={comment}
                name="message"
              />
            </div>
            <div className="ContactForm__Form__Third-Line">
              <a
                href="https://wa.link/yejqyh"
                style={{ textDecoration: 'none', color: 'white' }}
              >
                <div
                  className="ContactForm__Form__Third-Line__Button"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={whatsapp}
                    style={{
                      width: '4rem',
                      height: '4rem',
                      marginRight: '2rem',
                    }}
                  />
                  <div>Connect on Whatsapp</div>
                </div>
              </a>

              <button
                className="ContactForm__Form__Third-Line__Button"
                style={{ padding: '1.8rem 3rem' }}
              >
                Submit
              </button>
            </div>
          </motion.form>
        )}
      </AnimatePresence>
    </div>
  );
};
export default ContactForm;
